/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkAccountHolderIngest} from '../api'

export const useMutationBulkAccountHolderIngest = createReactQueryMutationHook('bulkAccountHolderIngest', bulkAccountHolderIngest)
